import PauseIcon from "@mui/icons-material/Pause";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { Box, Container } from "@mui/system";
import { motion } from "framer-motion";
import CastButton from "./CastButton";
import SongArtwork from "./SongArtwork";
import { useAudioControls, useAudioMiniPlayerState } from "./useAudio";

import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";

const AudioPlayerMini = () => {
  const { pause, resume, open } = useAudioControls();
  const { currentSong, isPlaying, isCasting, castingDeviceName } =
    useAudioMiniPlayerState();

  if (!currentSong) return null;

  const handlePlayPause = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (isPlaying) {
      pause();
    } else {
      resume();
    }
  };

  return (
    <Paper
      elevation={8}
      className="dark"
      data-mui-color-scheme="dark"
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100vw",
        px: 2,
        pr: 4,
        py: 1,
        borderRadius: 0,
        cursor: "pointer",
        userSelect: "none",
        zIndex: 10,
      }}
      onClick={() => open()}
    >
      <Container
        disableGutters
        maxWidth="md"
        sx={{ flex: 1, alignItems: "center", gap: 1.5 }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Box
            sx={{ flex: 1, display: "flex", alignItems: "center", gap: 1.5 }}
          >
            {/* Artwork */}
            <Box
              sx={{
                position: "relative",
                borderRadius: 1,
                flexShrink: 0,
              }}
            >
              <Box
                component={motion.div}
                layoutId={`artwork-player-${currentSong.id}`}
                sx={{ width: "100%", height: "100%", zIndex: 9999 }}
              >
                <SongArtwork hidePlayingBars song={currentSong} size={40} />
              </Box>
            </Box>

            {/* Title + description */}
            <Box
              sx={{
                flex: 1,
                maxWidth: "calc(100vw - 200px)",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }}
            >
              <Typography variant="body2" noWrap sx={{
                fontWeight: 700
              }}>
                {currentSong.title}
              </Typography>
              {isCasting ? (
                <Typography
                  variant="caption"
                  noWrap
                  sx={{ color: "primary.main", opacity: 0.9, display: "block" }}
                >
                  {castingDeviceName
                    ? `Redare pe ${castingDeviceName}`
                    : "Redare pe TV"}
                </Typography>
              ) : (
                currentSong.description && (
                  <Typography
                    variant="caption"
                    noWrap
                    sx={{
                      color: "common.white",
                      opacity: 0.7,
                      display: "block",
                    }}
                  >
                    {currentSong.description}
                  </Typography>
                )
              )}
            </Box>
          </Box>

          {/* Cast button */}
          <Box onClick={(e) => e.stopPropagation()}>
            <CastButton />
          </Box>

          {/* Play/Pause */}
          <IconButton
            onClick={handlePlayPause}
            aria-label={isPlaying ? "Oprește" : "Redă"}
            size="small"
            sx={{ color: "common.white" }}
          >
            {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
          </IconButton>
        </Box>
      </Container>
    </Paper>
  );
};

export default AudioPlayerMini;
